// Phase 2 - Advisory Committee Constants (#28)

// Committee user type
export const COMMITTEE_USER_TYPE = 4;

// Allocation audit status for committee reports
export const ALLOCATION_AUDIT_STATUS = [
  { name: "Initiated", value: "1" },
  { name: "Wait List Generated", value: "2" },
  { name: "Calling In Progress", value: "3" },
  { name: "Accepted", value: "5" },
  { name: "Declined", value: "6" },
  { name: "Terminated", value: "13" },
  { name: "Transplant Surgery", value: "28" },
  { name: "Allocated to Other State", value: "41" },
  { name: "Tissue Bank", value: "42" },
  { name: "Process Closed", value: "44" },
];

// Committee report types
export const COMMITTEE_REPORT_TYPES = [
  { name: "Allocation Audit Trail", value: "AUDIT" },
  { name: "Transplant Summary", value: "SUMMARY" },
  { name: "Hospital Performance", value: "HOSPITAL" },
  { name: "Organ Utilization", value: "ORGAN" },
];
